import React from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import LinearProgress from '@mui/material/LinearProgress';
import DEFAULT_PROGRESS_BAR_CLASS_NAME from '../../../theme/constants/linear-progress';
import { DEFAULT_LINK_CLASS_NAME } from '../../../theme/constants/link';

const ProgressBarStepper = ({
  currentStep,
  totalSteps,
  stepTitle,
  progress,
  onBack,
  backLabel,
  nextLabel,
  secondaryNextLabel,
  showBackButton,
  showNextLabel,
}) => (
  <Stack spacing={2} sx={{ width: '100%' }}>
    {/* Top section with navigation and step info */}
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        width: '100%',
      }}
    >
      {/* Left: Back button */}
      <Box sx={{ minWidth: '100px', alignSelf: 'flex-end' }}>
        {showBackButton && (
        <Link
          onClick={onBack}
          className={DEFAULT_LINK_CLASS_NAME}
        >
          <Typography variant="small_1" fontWeight={700}>
            {`< ${backLabel}`}
          </Typography>
        </Link>
        )}
      </Box>

      {/* Center: Step info */}
      <Stack spacing={0.5} alignItems="center" sx={{ flex: 1 }}>
        <Typography
          variant="small_1"
          sx={{
            color: 'gray.A400',
            fontWeight: 400,
            textTransform: 'uppercase',
            letterSpacing: '2px',

          }}
          lineHeight="24px"
        >
          {`PASO ${currentStep}/${totalSteps}`}
        </Typography>
        <Typography
          variant="small_2"
          sx={{
            color: 'gray.A700',
            fontWeight: 700,
            textTransform: 'uppercase',
          }}
        >
          {stepTitle}
        </Typography>
      </Stack>

      {/* Right: Next button */}
      <Stack spacing={0.5} alignItems="flex-end" sx={{ minWidth: '100px' }}>
        {showNextLabel && (
        <>
          <Typography
            variant="small_1"
            sx={{
              color: 'gray.A400',
              fontWeight: 400,
            }}
          >
            {nextLabel}
          </Typography>
          {secondaryNextLabel && (
          <Typography
            variant="small_1"
            sx={{
              color: 'gray.A400',
              fontWeight: 400,
              lineHeight: '24px',
            }}
          >
            {secondaryNextLabel}
          </Typography>
          )}
        </>
        )}
      </Stack>
    </Box>
    <LinearProgress
      variant="determinate"
      value={progress}
      className={DEFAULT_PROGRESS_BAR_CLASS_NAME}
    />
  </Stack>
);

ProgressBarStepper.propTypes = {
  currentStep: PropTypes.number,
  totalSteps: PropTypes.number.isRequired,
  stepTitle: PropTypes.string.isRequired,
  progress: PropTypes.number.isRequired,
  onBack: PropTypes.func,
  backLabel: PropTypes.string,
  nextLabel: PropTypes.string,
  secondaryNextLabel: PropTypes.string,
  showBackButton: PropTypes.bool,
  showNextLabel: PropTypes.bool,
};

ProgressBarStepper.defaultProps = {
  currentStep: 1,
  onBack: () => {},
  backLabel: 'VOLVER',
  nextLabel: 'Siguiente',
  secondaryNextLabel: '',
  showBackButton: true,
  showNextLabel: true,
};

export default ProgressBarStepper;
